import { render, staticRenderFns } from "./AuthoritiesRegister.vue?vue&type=template&id=3d761ce1&scoped=true"
import script from "./AuthoritiesRegister.vue?vue&type=script&lang=js"
export * from "./AuthoritiesRegister.vue?vue&type=script&lang=js"
import style0 from "./AuthoritiesRegister.vue?vue&type=style&index=0&id=3d761ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d761ce1",
  null
  
)

export default component.exports